export const grey = {
  light: '#E4E6EB',
  medium: '#767679'
} as const;

export const theme = {
  primary: '#230056',
  secondaryGrey: '#f2f4f9',
  secondary: '#6401F6',
  labels: '#a366fc',
  warning: '#FC615B',
  grey,
  legacy: {
    red: {
      light: '#FF6F6A',
      dark: '#D72721'
    },
    orange: {
      light: '#EFB708',
      dark: '#E67C12'
    },
    orangeLighter: {
      light: '#F5DD00',
      dark: '#F1BC00'
    },
    bluish: {
      light: '#3083FF',
      dark_or_yellowBlue: '#F1F124'
    },
    green: {
      light: '#68D786',
      dark: '#3ADB66'
    }
  },
  gauge: {
    red: '#E13C18',
    orange: '#E67C12',
    yellow: '#EFB708',
    green: '#1FB832'
  }
} as const;
